// extracted by css-extract-rspack-plugin
export default {"summaryText":"deedS3OfcsMsswTL","projectTypeTitle":"kO3TdV_JvaUcdUYM","summaryGrid":"d1LeV6VHkUMunwC5"};